import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { post } from 'app/shared/utils/fetchr';
import { sendErrorToast, sendSuccessToast } from 'app/shared/toasts/actions';
import { RISK_QUERY_KEYS } from 'app/modules/riskRatings/queries/keys';

interface ClearRiskScoreOverridePayload {
  comment: string;
}

export const useClearRiskScoreOverride = (entityExternalId: string) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: (payload: ClearRiskScoreOverridePayload) =>
      post(`/risk/entities/${entityExternalId}/override`, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: RISK_QUERY_KEYS.getEntityRiskScore(entityExternalId),
      });
      queryClient.invalidateQueries({
        queryKey: RISK_QUERY_KEYS.fetchOverriddenEntitiesByRiskModelBase(),
      });
      dispatch(sendSuccessToast('Successfully removed risk score override.'));
    },
    onError: () =>
      dispatch(
        sendErrorToast(
          'Failed to remove risk score override. Please try again.',
        ),
      ),
  });
};
